import type Phaser from 'phaser';
import type { ControlState } from './KeyboardAdapter';

type Bounds = { x: number; y: number; width: number; height: number };

function makeButton(scene: Phaser.Scene, label: string, bounds: Bounds, onDown: () => void, onUp: () => void) {
  const { x, y, width, height } = bounds;
  const zone = scene.add.zone(x + width / 2, y + height / 2, width, height).setScrollFactor(0).setDepth(1000);
  zone.setInteractive();
  const text = scene.add.text(zone.x, zone.y, label, {
    fontFamily: 'monospace',
    fontSize: '28px',
    color: '#ffffff',
  }).setOrigin(0.5).setScrollFactor(0).setDepth(1001);
  zone.on('pointerdown', () => {
    onDown();
    text.setAlpha(0.6);
  });
  zone.on('pointerup', () => {
    onUp();
    text.setAlpha(1);
  });
  zone.on('pointerout', () => {
    onUp();
    text.setAlpha(1);
  });
  return zone;
}

export function createVirtualControls(scene: Phaser.Scene, target: ControlState) {
  const w = scene.scale.width;
  const h = scene.scale.height;
  const rowY = h - 72;
  const vs = { left: false, right: false, up: false, jump: false, jumpHeld: false, action: false };
  makeButton(scene, '\u2190', { x: 16, y: rowY, width: 72, height: 56 }, () => { vs.left = true; }, () => { vs.left = false; });
  makeButton(scene, '\u2192', { x: 96, y: rowY, width: 72, height: 56 }, () => { vs.right = true; }, () => { vs.right = false; });
  makeButton(scene, '\u2191', { x: w - 248, y: rowY, width: 72, height: 56 }, () => { vs.up = true; }, () => { vs.up = false; });
  makeButton(scene, 'J', { x: w - 160, y: rowY, width: 72, height: 56 }, () => {
    vs.jump = true;
    vs.jumpHeld = true;
    vs.action = true;
  }, () => {
    vs.jump = false;
    vs.jumpHeld = false;
    vs.action = false;
  });
  // Merge virtual state on top of keyboard state each frame
  scene.events.on('update', () => {
    if (vs.left) target.left = true;
    if (vs.right) target.right = true;
    if (vs.up) target.up = true;
    if (vs.jumpHeld) target.jumpHeld = true;
    if (vs.jump) target.jump = true;
    if (vs.action) target.action = true;
  });
}
